/**
 * Helpers de permisos del cliente, espejo de la semántica del backend.
 *
 * El backend decide los permisos (`UserManager.has_permission`); el cliente solo
 * los **usa para pintar UI** (`docs/frontend_architecture.md`, Pr. 5). Estas
 * funciones replican el criterio mínimo necesario para el gating de la sesión:
 * el permiso comodín `all` (que tiene el admin) concede todo, igual que en
 * `user_service.has_permission`.
 */
import type { AuthUser } from "@/features/auth/types";

/** Permiso comodín del backend: concede todos los permisos (lo tiene el admin). */
export const ALL_PERMISSIONS = "all";

/** `true` si el usuario tiene `permission` (o el comodín `all`). */
export function userHasPermission(user: AuthUser, permission: string): boolean {
  const perms = user.permissions;
  return perms.includes(ALL_PERMISSIONS) || perms.includes(permission);
}

/**
 * Indica si el usuario opera sobre TODAS las sedes (== multi-sede).
 *
 * Espejo de `_user_has_all_sedes_access` del backend (`application/api/
 * decorators.py`): el rol `admin` ve todas las sedes; también quien tenga el
 * permiso `all`. Determina si la UI muestra el selector de sede.
 */
export function userIsMultiSede(user: AuthUser): boolean {
  return user.role === "admin" || user.permissions.includes(ALL_PERMISSIONS);
}
